function colorFor(value, tone, invert) {
  if (invert) {
    if (value < 40) return "text-[--success]";
    if (value > 70) return "text-[--danger]";
    return "text-[--ink]";
  }
  return tone === "primary" ? "text-[--accent]" : "text-[--ink]";
}

export default function MarketScoreCard({
  label,
  value,
  unit = "",
  tone = "default",
  invert = false,
  sub,
  testid,
}) {
  const colorClass = colorFor(value, tone, invert);
  return (
    <div data-testid={testid} className="p-6 border-r last:border-r-0 border-[--line] relative">
      <div className="overline mb-3">{label}</div>
      <div className={`font-display font-black tracking-tighter leading-none text-5xl ${colorClass}`}>
        {value}
        {unit && <span className="text-base font-mono text-[--ink-muted] ml-1">{unit}</span>}
      </div>
      {sub && <div className="text-xs text-[--ink-muted] mt-3 font-mono">{sub}</div>}
    </div>
  );
}
